import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import AppLayout from '../layout/AppLayout';
import GA from '../../utils/googleAnalytics';

// Route tracker component for Google Analytics
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    GA.logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

export default function Router() {
  // Initialize GA on mount
  useEffect(() => {
    GA.init();
  }, []);

  return (
    <BrowserRouter>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <RouteTracker />
          <Routes>
            <Route path="/*" element={<AppLayout />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
